import { CloseOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/react-hooks";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  message,
  Row,
  Select,
  Tooltip,
} from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { INSERT_ANNOUNCEMENT } from "../../../Graphql/mutations";
import {
  GET_BUSINESS_DETAILS,
  GET_EMPLOYEE_LIST,
} from "../../../Graphql/queries";
import { Loader } from "../../Loader";
import "./AddAnnouncementDrawer.less";
const { TextArea } = Input;

export const AddAnnouncementDrawer = ({
  visible,
  toggleDrawer,
  onSendAnnouncementSuccess,
}) => {
  const [form] = Form.useForm();
  const [locationList, setLocationList] = useState([]);
  const [sendToOptions, setSendToOptions] = useState([]);
  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [type_id, setTypeId] = useState(0);
  const [currentUserAccessType, setCurrentUserAccessType] = useState();

  const typesList = [
    { id: 1, name: "Send to business" },
    { id: 2, name: "Send to locations" },
    { id: 3, name: "Send to employees" },
  ];

  const { data: businessData, loading: businessDataLoading } = useQuery(
    GET_BUSINESS_DETAILS,
    {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    }
  );

  const { data: employeesList, loading: employeeListLoading } = useQuery(
    GET_EMPLOYEE_LIST,
    {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    }
  );

  const [INSERT_ANNOUNCEMENT_MUTATION, { loading: isInsertingAnnouncement }] =
    useMutation(INSERT_ANNOUNCEMENT);

  useEffect(() => {
    if (businessData) {
      setCurrentUserAccessType(
        businessData.businessDetailsByUser[0].userDetails?.accessDetails
          ?.access_level
      );

      let locationList =
        businessData.businessDetailsByUser[0].businessDetails.locations.flatMap(
          ({ locationDetails: { location_id, location_name } }) => {
            return [
              {
                id: location_id,
                name: location_name,
              },
            ];
          }
        );
      setLocationList(locationList);
    }
  }, [businessData]);

  useEffect(() => {
    if (employeesList && currentUserAccessType) {
      let formattedUserList = [];
      employeesList.employeesByLocation.forEach(({ locationDetails }) => {
        let userData = locationDetails.users.flatMap(
          ({ userDetails, userRole }) => {
            if (
              parseInt(userRole.accessDetails.type_id) >
              parseInt(currentUserAccessType)
            ) {
              return [
                {
                  id: userDetails.user_id,
                  name: userDetails.first_name + " " + userDetails.last_name,
                  location_id: locationDetails.location_id,
                },
              ];
            } else {
              return null;
            }
          }
        );
        formattedUserList.push(...userData.filter((x) => x));
      });

      setUserList(formattedUserList);
      setIsLoading(false);
    }
  }, [employeesList, currentUserAccessType]);

  const onTypeSelect = (type_id) => {
    form.setFieldsValue({
      ["users"]: [],
    });
    setTypeId(type_id);
    if (type_id === 2) {
      setSendToOptions(locationList);
    } else if (type_id === 3) {
      setSendToOptions(userList);
    }
  };

  const onAddEmployee = async (values) => {
    let requestParams = {};
    requestParams.created_by = localStorage.getItem("user_id");
    requestParams.announcement_message = values.announcement_message;
    if (values.type_id != 3) {
      requestParams.users = userList.flatMap(({ id, location_id }) => {
        if (values.type_id === 2 && values.users.includes(location_id)) {
          // For type_id == 2 -> For Send announcement to all users of selected locations
          return [
            {
              user_id: id,
            },
          ];
        } else if (values.type_id === 1) {
          // For type_id == 1 -> For Send announcement to all users of business
          return [
            {
              user_id: id,
            },
          ];
        }
      });
    } else {
      // For type_id == 3 -> For Send announcement to all selected users
      requestParams.users = values.users.flatMap((id) => {
        return [
          {
            user_id: id,
          },
        ];
      });
    }
    requestParams.users = requestParams.users.filter((x) => !!x);

    try {
      const isInsertSuccessful = await INSERT_ANNOUNCEMENT_MUTATION({
        variables: requestParams,
      });
      if (!isInsertSuccessful.errors) {
        message.success("Announcement sent successfully");
        onSendAnnouncementSuccess();
      } else {
        message.error("Something went wrong.");
      }
    } catch (error) {}
  };

  return (
    <Drawer
      placement="right"
      closable={false}
      width={720}
      visible={visible}
      maskStyle={{ backgroundColor: "#000000CC" }}
    >
      <Row className="headerRow" justify="space-between" align="middle">
        <Col>
          <h5 className="mb-0">Send Announcement</h5>
        </Col>
        <Col>
          <Button type="text" icon={<CloseOutlined />} onClick={toggleDrawer} />
        </Col>
      </Row>
      {businessDataLoading || employeeListLoading ? (
        <Loader />
      ) : (
        <Form form={form} onFinish={onAddEmployee}>
          <Row className="mt-4 mx-3" gutter={16}>
            <Col span={12}>
              <Tooltip
                trigger={["focus"]}
                title="Select Type"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="type_id"
                  rules={[
                    {
                      required: true,
                      message: "Please select type",
                    },
                  ]}
                >
                  <Select placeholder="Select Type" onSelect={onTypeSelect}>
                    {typesList.map((type, index) => (
                      <Select.Option key={index} value={type.id}>
                        {type.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Tooltip>
            </Col>
          </Row>
          {type_id > 1 && (
            <Row className="mx-3" gutter={16}>
              <Col span={12}>
                <Tooltip
                  trigger={["focus"]}
                  title="Select"
                  placement="topLeft"
                  overlayClassName="numeric-input"
                >
                  <Form.Item
                    name="users"
                    rules={[
                      {
                        required: true,
                        message: "Please select atleast one",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select"
                      dropdownClassName="customDropdown"
                    >
                      {sendToOptions.map((data, index) => (
                        <Select.Option key={index} value={data.id}>
                          {data.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Tooltip>
              </Col>
            </Row>
          )}

          <Row className="mx-3" gutter={16}>
            <Col span={24}>
              <Tooltip
                trigger={["focus"]}
                title="Announcement Message"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="announcement_message"
                  rules={[
                    {
                      required: true,
                      message: "Announcement message is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <TextArea
                    className="customTextarea"
                    rows={4}
                    name="announcement_message"
                    placeholder="Announcement message"
                  />
                </Form.Item>
              </Tooltip>
            </Col>
          </Row>
          <div className="mt-3 mb-4 text-center">
            <Button
              type="primary"
              shape="round"
              size="large"
              className="h-auto"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        </Form>
      )}
    </Drawer>
  );
};
